import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  contentRoot: {
    paddingTop: 4,
  },
  inputGroup: {
    marginBottom: 8,
  },
  label: {
    marginBottom: 6,
  },
  labelRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    marginBottom: 6,
  },
  require: {
    marginLeft: 2,
    color: Colors.Red6,
    fontSize: 18,
    fontWeight: 500,
    marginBottom: 5,
  },
  searchIcon: {
    '&.MuiSvgIcon-root': {
      color: Colors.Grey6,
      fontSize: 18,
    },
  },
  avatar: {
    marginRight: 2,
    '&.MuiAvatar-root': {
      width: 24,
      height: 24,
      fontSize: 0,
    },
  },
  adornmentStart: {
    '&.MuiInputAdornment-root': {
      marginRight: 6,
    },
  },
  autoSize: {
    '& .MuiOutlinedInput-root': {
      height: 50,
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 12px',
      fontSize: 14,
    },
  },
  selectEdition: {
    width: '100%',
    height: 50,
    marginTop: -20,
    '& .MuiSelect-select': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  textFieldHidden: {
    display: 'none',
  },
  infoBlock: {
    background: Colors.Grey1,
    border: `1px solid ${Colors.Grey3}`,
    borderRadius: 8,
    padding: 16,
  },
  infoIntro: {
    marginBottom: 8,
    color: Colors.Grey8,
  },
  noteHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 8,
    gap: 6,
  },
  noteIcon: {
    '&.MuiSvgIcon-root': {
      color: Colors.Grey7,
      fontSize: 18,
    },
  },
  noteTitle: {
    color: Colors.Black,
  },
  infoList: {
    margin: 0,
    paddingLeft: 18,
  },
  infoItem: {
    color: Colors.Grey8,
  },
}));

export default useStyles;
